import * as React from 'react';

function SvgCalendar(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M22.307 7.052a2.857 2.857 0 00-2.857-2.857h-.714V3.5a.728.728 0 00-.68-.734.715.715 0 00-.749.713v.715h-10V3.5a.728.728 0 00-.68-.734.714.714 0 00-.748.713v.715h-.715a2.857 2.857 0 00-2.857 2.857v.536a.179.179 0 00.179.178h19.643a.179.179 0 00.178-.178v-.536zm-20 12.857a2.857 2.857 0 002.857 2.857H19.45a2.857 2.857 0 002.857-2.857V9.373a.178.178 0 00-.178-.178H2.486a.179.179 0 00-.179.178V19.91z" })));
}

export default SvgCalendar;
